import Service 			from "./../../Libs/Service";

let Screen = new Service({

	Name: "Screen",

	Libraries: [],

	Events: {

	},

	Actions: {

		//Получение всех экранов проекта или версии
		"Screens": function(screens, data) {

			if (data.ScreensProjectId) {

				this.setScreens(screens);

				//Первоначальная загрузка экранов всех версий проекта
				Broadcast.call("Project Screens Loaded");

			} else if (data.ScreensVersionId) {

				this.setScreens(screens);

				//Первоначальная загрузка экранов одной версии (дублирование версии или создание из шаблона)
				Broadcast.call("Version Screens Loaded");

			}

		},

		"Screen": function(screen, data) {

			let oldScreen = this.ScreensByVersionByCodename[data.ScreenVersionId]?.[data.ScreenCodename];

			this.setScreen(data.ScreenVersionId, data.ScreenCodename, screen);

			this.detectScreenChanges(oldScreen, screen);

		}

	},

	init() {

		this.ScreensByVersionByCodename = {};

	},

	setScreens(versionsScreens) {

		_.each(versionsScreens, (versionScreens, versionId) => {

			this.ScreensByVersionByCodename[versionId] = versionScreens;

		});

	},

	setScreen(versionId, screenCodename, screen) {

		this.ScreensByVersionByCodename[versionId][screenCodename] = screen;

	},

	detectScreenChanges(oldScreen, newScreen) {

		//TODO:

	},

	getVersionScreens(version) {

		return this.ScreensByVersionByCodename[version.id];

	}

});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.DisplayScreen) Screen = window.DisplayScreen;
else window.DisplayScreen = Screen;

export { Screen }

